module.exports = __webpack_public_path__ + "img/5.363afe7f.webp";